import template from './prems-discount-customer-group-selector.html.twig';

const { Component, Context } = Shopware;
const { EntityCollection, Criteria } = Shopware.Data;

Component.register('prems-discount-customer-group-selector', {
    template,
    inheritAttrs: false,

    inject: ['repositoryFactory'],

    props: {
        discountCategory: {
            type: Object,
            required: false,
            default: null
        },
    },
    computed: {
        customerGroupRepository() {
            return this.repositoryFactory.create('customer_group');
        },
        customerGroupIds: {
            get() {
                this.ensureValueExist();
                return Object.keys(this.discountCategory.discountCustomerGroupIds).length > 0 ?  this.discountCategory.discountCustomerGroupIds : null;
            },
            set(customerGroupIds) {
                this.ensureValueExist();
                this.discountCategory.discountCustomerGroupIds = customerGroupIds;
            }
        },
    },

    created() {
        this.createdComponent();
    },

    data() {
        return {
            customerGroups: null
        };
    },

    methods: {
        createdComponent() {
            this.customerGroups = new EntityCollection(
                this.customerGroupRepository.route,
                this.customerGroupRepository.entityName,
                Context.api
            );

            if (!this.customerGroupIds) {
                return Promise.resolve();
            }

            const criteria = new Criteria();
            criteria.setIds(this.customerGroupIds);

            return this.customerGroupRepository.search(criteria, Context.api).then((customerGroups) => {
                this.customerGroups = customerGroups;
            });
        },
        ensureValueExist() {
            if (typeof this.discountCategory.discountCustomerGroupIds === 'undefined' || this.discountCategory.discountCustomerGroupIds === null) {
                this.discountCategory.discountCustomerGroupIds = {};
            }
        },
        setCustomerGroupIds(customerGroups) {
            this.customerGroupIds = customerGroups.getIds();
            this.customerGroups = customerGroups;
        }
    }
});
